import { useNavigate } from 'react-router-dom'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'

export default function BackButton(props) {
    const navigate = useNavigate()
    const content = (
        <>
            <ArrowBackIosNewIcon className="backButton__icon" />
            <span className="backButton__label">{props.text ? props.text : 'Назад'}</span>
        </>
    )

    if (props.onClickButton) {
        return (
            <button
                onClick={props.onClick}
                className={`backButton ${props.className || ''}`}
                aria-label={props.text || 'Назад'}
            >
                {content}
            </button>
        )
    }

    return (
        <button
            onClick={() => navigate(-1)}
            className={`backButton ${props.className || ''}`}
            aria-label={props.text || 'Назад'}
        >
            {content}
        </button>
    )
}
